export default __webpack_public_path__ + "files/bf93ee8f5aa461726113f3302541ae99.mp3";